import { useState, useEffect, useMemo } from 'react';
import { getTodayDate } from '../../util/dateUtil';
import SlotApi from '../../api/SlotApi';

const CATEORIES = [
    { label: '패션의류', value: '패션의류' },
    { label: '패션잡화', value: '패션잡화' },
    { label: '화장품', value: '화장품/미용' },
    { label: '디지털/가전', value: '디지털/가전' },
    { label: '가구/인테리어', value: '가구/인테리어' },
    { label: '출산/육아', value: '출산/육아' },
    { label: '식품', value: '식품' },
    { label: '스포츠/레저', value: '스포츠/레저' },
    { label: '생활/건강', value: '생활/건강' },
    { label: '여가/생활편의', value: '여가/생활편의' },
    { label: '도서', value: '도서' },
]

function normalizeInput(raw) {
    // case: { data: [ [date, jsonString], ... ] }
    if (raw && Array.isArray(raw.data)) {
      const arr = raw.data.map(([date, jsonString]) => {
        let items = [];
        try { items = JSON.parse(jsonString); } catch (e) { console.error("JSON parse error:", e); }
        return { date, items };
      });
      return arr;
    }
  
    // case: already array of snapshots
    if (Array.isArray(raw)) {
      return raw.map(s => ({ date: s.date, items: s.items || [] }));
    }
  
    throw new Error("지원되지 않는 입력 형식입니다.");
  }
  
  function addChangedToLatestSnapshots(raw) {
    const normalized = normalizeInput(raw);
    if (normalized.length < 2) return normalized; // 비교할 이전 날짜가 없음
  
    // 최신/이전 찾기 (날짜 기준으로 정렬하여 끝에서 두 개)
    const sorted = [...normalized].sort((a, b) => new Date(a.date) - new Date(b.date));
    const prev = sorted[sorted.length - 2];
    const curr = sorted[sorted.length - 1];
  
    // prev -> category별로 (keyword -> rank) 매핑 생성
    const prevMap = new Map();
    (prev.items || []).forEach(item => {
      const m = new Map();
      (item.keywords || []).forEach((kw, idx) => m.set(String(kw).trim(), idx + 1));
      prevMap.set(item.category, m);
    });
  
    // curr 복사본 생성 (원본 변경 방지)
    const currCopy = JSON.parse(JSON.stringify(curr));
  
    // curr의 각 카테고리에서 키워드별로 changed 판정
    currCopy.items = (currCopy.items || []).map(item => {
      const prevForCat = prevMap.get(item.category);
      const keywords = item.keywords || [];
      // keywords 를 객체 배열로 변환: { keyword, changed }
      const newKeywords = keywords.map((kw, idx) => {
        const kwStr = String(kw).trim();
        const currRank = idx + 1;
        if (!prevForCat || !prevForCat.has(kwStr)) {
          // 이전에 없던 키워드 => 신규 (빈값)
          return { keyword: kw, changed: "hyphen" };
        }
        const prevRank = prevForCat.get(kwStr);
        if (currRank < prevRank) return { keyword: kw, changed: "rank-up" };     // 순위 상승
        if (currRank > prevRank) return { keyword: kw, changed: "rank-down" };   // 순위 하락
        return { keyword: kw, changed: "hyphen" };                                 // 변동 없음
      });
  
      return { ...item, keywords: newKeywords };
    });
  
    // 원본 순서를 유지하면서 최신 날짜 항목만 교체해서 반환
    const result = normalized.map(s => (s.date === curr.date ? currCopy : s));
    return result;
  }

const PopularSearchList = () => {

    const [ curCategory, setCurCategory ] = useState(CATEORIES[0].value);
    const [ ranks, setRanks ] = useState([{ keywords: [] }]);
    const [ rotateIndex, setRotateIndex ] = useState(0);

    const keywords = useMemo(
        () => (ranks.find(r => r.category === curCategory)?.keywords ?? []).slice(0, 8),
        [ranks, curCategory]
    );

    const handleCategoryChg = e => {
        setCurCategory(e.target.value);
    }

    useEffect(() => {
        SlotApi.getPopularKeyword().then(rslt => {
            const calRanks = addChangedToLatestSnapshots(rslt) || [];
            setRanks(calRanks[0].items);
        });
    }, []);

    useEffect(() => {
        setRotateIndex(0);
    }, [curCategory]);

    useEffect(() => {
        if (keywords.length === 0) return undefined;

        const timer = setInterval(() => {
            setRotateIndex((prev) => (prev + 1) % keywords.length);
        }, 5000);

        return () => clearInterval(timer);
    }, [keywords]);

    return (
        <div class="header-rank-area">
            <div class="header-rank-head">
                <h1>{getTodayDate('. ', -1)}</h1>
                <p>네이버쇼핑 인기검색어</p>
            </div>
            <div class="header-rank-filter">
                <select onChange={handleCategoryChg} value={curCategory}>
                    {CATEORIES.map(category =>
                        <option value={category.value}>{category.label}</option>
                    )}
                </select>
            </div>

            <div class="header-rank-list">
                <ul>
                    {keywords[rotateIndex] && (
                        <li>
                            <a>
                                <span>{rotateIndex + 1}</span>
                                <span>{keywords[rotateIndex].keyword}</span>
                                <i className={`icon icon-${keywords[rotateIndex].changed}`}></i>
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    )
}

export default PopularSearchList;